import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';

interface IRowSectionTitle {
  icon: React.ReactNode;
  label: string;
  labelWidth?: number;
}

function RowSectionTitle({ icon, label, labelWidth = 200 }: IRowSectionTitle) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: 'flex-start', minWidth: labelWidth, width: { sm: labelWidth, xs: '100%' } }}
    >
      <Box sx={{ alignItems: 'center', color: 'secondary.main', display: 'flex' }}>{icon}</Box>
      <Typography sx={{ fontWeight: 'medium' }} variant="body1">
        {label}
      </Typography>
    </Stack>
  );
}

export default RowSectionTitle;
